import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useTaskOverviewViewModel = (attempt) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [emailHistory, setEmailHistory] = useState({});

  const getEmailHistory = () =>
    stateManager.run(async () => {
      const response = await taskService.attempts.getEmailHistory({
        attemptId: attempt.id,
      });

      if (response.status === HTTP_STATUSES.OK) {
        const recentEmails = response.data.reduce((acc, email) => {
          if (
            !acc[email.emailType] ||
            new Date(email.createdOn) > new Date(acc[email.emailType].createdOn)
          ) {
            acc[email.emailType] = email;
          }
          return acc;
        }, {});

        setEmailHistory(recentEmails);
      }
    });

  return {
    isLoading,
    emailHistory,
    getEmailHistory,
  };
};
